// 首页API接口

import {postRequest} from "@/utils/operation/request"

// 获取用户信息
export const getUserInformation = (params) => postRequest("/auth", params, 'post')